import api from './client';

export interface MaintenanceItemIn {
  warehouse_item_id: number;
  quantity: number;
  price_per_unit: number;
}

export interface MaintenanceItem {
  id: number;
  warehouse_item_id: number;
  warehouse_item: { id: number; name: string; unit: string };
  quantity: number;
  price_per_unit: number;
}

export interface MaintenanceLog {
  id: number;
  equipment_id: number;
  date: string;
  description: string;
  executor_id: number | null;
  executor: { id: number; first_name: string; last_name: string } | null;
  items: MaintenanceItem[];
}

export const getMaintenanceLogs = (equipment_id: number) =>
  api.get<MaintenanceLog[]>('/maintenance', { params: { equipment_id } }).then(r => r.data);

export const createMaintenanceLog = (data: {
  equipment_id: number;
  date: string;
  description: string;
  executor_id?: number;
  items: MaintenanceItemIn[];
}) => api.post<MaintenanceLog>('/maintenance', data).then(r => r.data);

export const deleteMaintenanceLog = (id: number) =>
  api.delete(`/maintenance/${id}`);
